<template>
  <a-dialog ref="dialog" name="resume_plan" :loading="loading" @open="opened" @close="$reset" size="small">
    <span slot="title">{{ $t('title') }}</span>
    <div slot="content">
      {{ $t('cancel-offer') }}
    </div>
    <span slot="actions">
        <v-btn color="warning" text @click="submit">{{ $t('actions.confirm') }}</v-btn>
    </span>
  </a-dialog>
</template>

<script>
export default {
  name: 'ResumePlanDialog',
  data () {
    return {
      subscription: null,
      loading: '',
    }
  },
  methods: {
    opened (subscription) {
      this.subscription = subscription
    },
    async submit () {
      try {
        this.loading = this.$t('save-cancelation')
        await this.subscription.resume()

        this.loading = this.$t('update-offer')
        await this.$account.fetch()

        this.$ui.success(this.$t('cancel-success'))
        if(this.$refs.dialog) this.$refs.dialog.close()
      } finally {
        this.loading = ''
      }
    }
  },
}
</script>

<style scoped>

</style>

<i18n>
{
	"en": {
		"cancel-offer": "Would you like to cancel the cancel of your offer ?",
		"cancel-success": "The cancellation of the termination has been registered successfully.",
		"save-cancelation": "Registration of cancellation ...",
		"title": "Cancel termination",
		"update-offer": "Updating your subscription ..."
	},
	"es": {
		"cancel-offer": "¿Le gustaría cancelar la rescisión de su oferta?",
		"cancel-success": "La cancelación de la rescisión se ha registrado con éxito.",
		"save-cancelation": "Registro de cancelación ...",
		"title": "Cancelar rescisión",
		"update-offer": "Actualizando su suscripción ..."
	},
	"fr": {
		"cancel-offer": "Souhaitez-vous annuler la résiliation de votre offre ?",
		"cancel-success": "L'annulation de la résiliation a été enregistrée avec succès.",
		"save-cancelation": "Enregistrement de l'annulation ...",
		"title": "Annuler la résiliation",
		"update-offer": "Mise à jour de votre souscription ..."
	},
	"it": {
		"cancel-offer": "Vuoi annullare la disdetta della tua offerta?",
		"cancel-success": "L'annullamento della disdetta è stato registrato con successo.",
		"save-cancelation": "Registrazione dell'annullamento ...",
		"title": "Annulla disdetta",
		"update-offer": "Aggiornamento del tuo abbonamento ..."
	},
	"pt": {
		"cancel-offer": "Deseja cancelar o cancelamento da sua oferta?",
		"cancel-success": "O cancelamento da rescisão foi registado com sucesso.",
		"save-cancelation": "Registo do cancelamento ...",
		"title": "Cancelar rescisão",
		"update-offer": "A atualizar a sua subscrição ..."
	},
	"pl": {
		"cancel-offer": "Czy chcesz anulować wypowiedzenie swojej oferty?",
		"cancel-success": "Anulowanie rozwiązania zostało pomyślnie zarejestrowane.",
		"save-cancelation": "Rejestrowanie anulowania ...",
		"title": "Anuluj rozwiązanie",
		"update-offer": "Aktualizacja Twojej subskrypcji ..."
	}
}
</i18n>
